import style from "./InfoBlock.module.scss";
import Image from "next/image";

function InfoBlock({ dictionary }) {
	const title = dictionary["Get an amazing AI-generated artwork based on your picture"] || "Get an amazing AI-generated artwork based on your picture";

	return (
		<section className={style.block}>
			<div className={style.content}>
				<Image className={style.icon} width={650} height={604} src={"/remove_back/avatar/info_icon.png"} loading="lazy" alt={title} />
				<div className={style.text}>
					<h2 className={style.title}>{title}</h2>
					<p className={style.description}>{dictionary["it's simple & easy to experiment with your photos"]}</p>
				</div>
			</div>
		</section>
	);
}

export default InfoBlock;
